export default __webpack_public_path__ + "static/media/devices_3.99d87808.png";